// extracted by mini-css-extract-plugin
module.exports = {"player":"TutorialDialog_player__3rlFS","loading":"TutorialDialog_loading__2fmA-","animate":"TutorialDialog_animate__2az5I"};